module.exports = __webpack_public_path__ + "img/aboutus-header-bg.38589246.png";